import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { fetchLabels, sendEmail } from './refer-a-friend-data.actions';

@Injectable()
export class ReferAFriendDataDispatcher {
  constructor(private _store: Store<any>) {}

  fetchLabels() {
    this._store.dispatch(fetchLabels());
  }

  sendEmail(email: string) {
    this._store.dispatch(sendEmail(email));
  }
}
